import { Component, OnDestroy, OnInit } from '@angular/core';
import { EnvironmentActions } from '@app/core/actions';
import * as fromRoot from '@app/reducers/index';
import { PriceFormaterPipe } from '@app/shared/pipes/price-formater.pipe';
import { DialogRef, } from '@ngneat/dialog';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import * as fromSignup from 'src/app/client/signup/reducers';
import { SubscriptionActions } from '@app/client/signup/subscription/actions';
import { distinctUntilChanged, first, Subscription, withLatestFrom } from 'rxjs';
import { computeOffer } from '@app/shared/helpers/price';
import { ListCountriesOutput } from '@smash-sdk/vat/types/10-2019/types/ListCountries/ListCountries';


@Component({
  selector: 'app-discover',
  templateUrl: './discover.component.html',
  styleUrls: ['./discover.component.scss'],
})
export class DiscoverComponent implements OnDestroy, OnInit {
  countryCurrency: ListCountriesOutput['countries'][0]['currency'];
  priceFormatted: string;
  subscriptions: Subscription[] = [];

  constructor(
    public ref: DialogRef,
    private readonly store$: Store<fromRoot.State & fromSignup.State>,
    private translateService: TranslateService,
  ) {

    this.countryCurrency = this.ref.data.countries.find((country: any) => country.countryCode === this.ref.data.countryCode)?.currency;

    this.subscriptions = [
      this.store$.pipe(
        withLatestFrom(
          this.store$.pipe(select(fromSignup.getPlanGroupLoaded)),
          this.store$.pipe(select(fromSignup.getPlans)),
          this.store$.pipe(select(fromRoot.getSelectedLanguage))
        ),
        first(([_, planGroupLoaded]) => planGroupLoaded),
        distinctUntilChanged()
      ).subscribe(([_, planGroupLoaded, plans, language]) => {
        if (planGroupLoaded) {
          const smashPremium2years = plans.find(plan => plan.currency === this.countryCurrency && plan.duration === '2years');
          const { offer, currency } = computeOffer({ plan: smashPremium2years });
          const priceFormater = new PriceFormaterPipe();
          this.priceFormatted = priceFormater.transform(offer, { language, currency });
        }
      })
    ];

    this.store$.dispatch(SubscriptionActions.loadPlans({ id: "Smash Premium" }));
  }

  ngOnInit(): void { }

  goFreemium(): void {
    this.store$.dispatch(EnvironmentActions.OnBoarding({ onBoardingState: { discoverProModal: 'hideForNow', counter: 1, lastVisit: moment().toISOString() } }));
    this.ref.close();
  }

  goPro(): void {
    const url = this.translateService.instant('MODAL_DISCOVER_PRO_PRO_BTN_LINK');
    this.store$.dispatch(EnvironmentActions.OnBoarding({ onBoardingState: { discoverProModal: 'hide', counter: 0 }, redirectToPricing: url }));
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    this.subscriptions.length = 0;
  }
}
